<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :loading="loading"
        class="mt-5"
        height="auto"
        :error-message="errorMessage"
        @submit="updateTinElorus"
    >
        {{ translations.description[lang] }}
        <b-text-field
            label="Elorus Client ID"
            v-model="elorusId"
            :readonly="!superUser"
            :error-messages="error.elorusId"
            :success="success.elorusId"
            @input="doUpdates.elorusId = !!elorusId"
        ></b-text-field>
        
        <b-text-field
            :label="translations.vat[lang]"
            v-model="tin"
            :error-messages="error.tin"
            :success="success.tin"
            @input="validateVatNumber"
        ></b-text-field>
        
        <b-text-field
            :label="translations.vatPercentage[lang]"
            v-model="vatPercentage"
            type="number"
            :error-messages="error.vatPercentage"
            :success="success.vatPercentage"
            @input="validateVatPercentage"
        ></b-text-field>
        <v-alert v-if="errorMessage" type="error">{{
                    errorMessage
                }}</v-alert>
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/tinElorus";
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";

export default {
    name: "TinElorus",

    mixins: [translations],

    
    data() {
        return {
            tin: '',
            vatPercentage: '',
            elorusId: '',
            success: {
                elorusId: null,
                tin: null,
                vatPercentage: null
            },
            error: {
                elorusId: '',
                tin: '',
                vatPercentage: ''
            },
            doUpdates: {
                elorusId: false,
                tin: false,
                vatPercentage: false
            }
        };
    },
  
    computed: {
        lang() {
            return this.$route.params.lang;
        },
        loading() {
            return this.$store.state.loyaltyPanel.businessProfile.loading.tin || this.$store.state.loyaltyPanel.businessProfile.loading.elorus || this.$store.state.loyaltyPanel.businessProfile.loading.vat_percentage;
        },

        errorMessageTin() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .tin;
        },
        resetSuccessTin() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .tin;
        },

        errorMessageElorus() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .elorus;
        },
        resetSuccessElorus() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .elorus;
        },

        errorMessageVatPercentage() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .vat_percentage;
        },
        resetSuccessVatPercentage() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .vat_percentage;
        },
        
        errorMessage() {
            let msg = ''
                if (this.error.tin && this.error.elorusId) {
                    msg = this.translations.errorMessage[this.lang]
                }

            return msg
        },

        ...mapState(["superUser"]),
        ...mapState("loyaltyPanel",["company"]),
        ...mapState("loyaltyPanel/businessProfile",["businessProfileData"]),

    },

    methods: {
        ...mapActions("loyaltyPanel/businessProfile", ["updateVatNumber","updateElorusClient","updateVatPercentage", "getBussinessProfile"]),
        ...mapActions("loyaltyPanel", ["getCompany"]),
        ...mapActions(["checkVatNumber"]),
        ...mapMutations(["setNotification"]),

        resetSuccess(){
            this.success.tin = false
            this.success.vatPercentage = false
            this.success.elorusId = false
        },  
        resetErrors(){
            this.error.tin = ''
            this.error.vatPercentage = ''
            this.error.elorusId = ''
        },
        resetDoUpdates(){
            this.doUpdates.tin = false
            this.doUpdates.vatPercentage = false
            this.doUpdates.elorusId = false
        },

        async validateVatNumber() {
            let isValid = false;
            this.error.tin = "";
            if (!this.tin) {
                this.error.tin = this.translations.errorTinRequired[
                    this.lang
                ];
                isValid = false;
            } else if (this.tin.length < 9 || this.tin.length > 12) {
                this.error.tin = this.translations.errorTinLength[
                    this.lang
                ];
                isValid = false;
            } else if (this.tin?.length >= 9 && this.tin?.length <= 12) {
                let res = await this.checkVatNumber({afm: this.tin, country_id: this.company?.country?.country_id});
                if (res.data?.status === 'success') {
                    this.error.tin = "";
                    isValid = true;
                } else if (res.data?.error) {
                    console.log(res.data)
                    this.error.tin = res.data?.message || "";
                    isValid = false;
                }
            }
            this.doUpdates.tin = isValid
            return isValid;
        },

        async validateVatPercentage() {
            let isValid = false;
            this.error.vatPercentage = "";
            if (!this.vatPercentage && this.vatPercentage !== 0) {
                this.error.vatPercentage = this.translations.errorVatPercentageRequired[
                    this.lang
                ];
                isValid = false;
            } else if (this.vatPercentage < 0 || this.vatPercentage > 100) {
                this.error.vatPercentage = this.translations.errorVatPercentageRange[
                    this.lang
                ];
                isValid = false;
            } else {
                this.error.vatPercentage = "";
                isValid = true;
            }
            this.doUpdates.vatPercentage = isValid
            return isValid;
        },

        async updateTinElorus(){
            this.resetSuccess()
            this.resetErrors()
            let successMessage = ''

            let tinRes 
            if (this.doUpdates.tin && this.validateVatNumber()) {
                tinRes = await this.updateVatNumber({type: 'tin', body:{vat_number: this.tin}})
                this.doUpdates.tin = false
                if (tinRes.status == 'success') {
                    this.success.tin = true
                }
            } 

            let elorusIdRes
            if (this.doUpdates.elorusId) {
                elorusIdRes = await this.updateElorusClient({type:'elorus', body:{elorus_customer_id: this.elorusId}})
                this.doUpdates.elorusId = false
                if (elorusIdRes.status == 'success') {
                    this.success.elorusId = true
                }
            } 

            let vatPercentageRes
            if (this.doUpdates.vatPercentage && this.validateVatPercentage()) {
                vatPercentageRes = await this.updateVatPercentage({type: 'vat_percentage', body:{vat_percentage: this.vatPercentage}})
                this.doUpdates.vatPercentage = false
                if (vatPercentageRes.status == 'success') {
                    this.success.vatPercentage = true
                }
            }

            if ( this.success.tin || this.success.elorusId || this.success.vatPercentage) {
                successMessage = this.translations[`successMessage${this.success.tin?'Tin':''}${this.success.vatPercentage?'VatPercentage':''}${this.success.elorusId?'Elorus':''}`]
                this.getCompany()
            } 
            if ( this.error.tin || this.error.elorusId || this.error.vatPercentage ) {
                this.getBussinessProfile()
            }

            if (successMessage?.[this.lang]) {
                this.setNotification({
                    show: true,
                    type: "success",
                    text: successMessage[this.lang]
                })
            }
        }
    },

    
    watch: {
        businessProfileData: {
            immediate: true,
            handler(val) {
                    this.tin = val?.vat_number || ''  
                    this.elorusId = val?.elorus_customer_id	 || ''  
            },
            deep: true
        },
        company: {
            immediate: true,
            handler(val) {
                const vatPercentage = val?.billing_details?.vat_percentage ?? val?.vat_percentage;
                this.vatPercentage = vatPercentage ?? '';
            },
            deep: true
        },
        errorMessageTin: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error.tin = `${this.tin ? this.tin + ': ' : ''}${val}`
                }
            },
            deep: true
        },
        errorMessageElorus: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error.elorusId = `${this.elorusId ? this.elorusId + ': ' : ''}${val}`
                }
            },
            deep: true
        },
        errorMessageVatPercentage: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error.vatPercentage = `${this.vatPercentage ? this.vatPercentage + ': ' : ''}${val}`
                }
            },
            deep: true
        },
        error: {
            immediate: true,
            handler(val) {
                if (val.elorusId || val.tin || val.vatPercentage) {
                    setTimeout(
                    () => this.resetErrors(),
                    8000
                );
                }
            },
            deep: true
        },
        
        success: {
            immediate: true,
            handler(val) {
                if (val.elorusId || val.tin || val.vatPercentage) {
                    setTimeout(
                    () => this.resetSuccess(),
                    8000
                );
                }
            },
            deep: true
        }
     
    }

};
</script>
